module.exports = __webpack_public_path__ + "static/media/backVideo.2c405d0.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/backVideo.mp4
// module id = USEe
// module chunks = 1